import Experience from '../Experience'
import Dxm from './Dxm'
import Environment from './Environment'
import Floor from './Floor'
import GSAP from 'gsap'

export default class World {
  constructor() {
    //setup
    this.experience = new Experience()
    this.camera = this.experience.camera
    this.scene = this.experience.scene
    this.resources = this.experience.resources

    //resources
    this.resources.on('ready', () => {
      //loader
      const loader = document.querySelector('.loader')
      const button = document.querySelector('.decouvrir')
      const main = document.querySelector('main')
      const audio = document.querySelector('audio')

      //close loader

      setTimeout(() => {
        GSAP.to(loader, { autoAlpha: 0 })
        loader.classList.add('loaderOff')
      }, 1500)

      //Intro main title
      GSAP.from(main, { y: 10, autoAlpha: 0, duration: 1.5 })
      GSAP.from(button, { autoAlpha: 0, duration: 1.5, delay: 1 })

      //Audio
      audio.muted = false
      audio.volume = 0.2
      audio.play()

      //setup
      this.dxm = new Dxm()
      this.floor = new Floor()
      this.environment = new Environment()
    })
  }
  update() {
    if (this.dxm) {
      this.dxm.update()
    }
  }
}
